export const setLinkColorVars = ({ color, activeColor, style }) => ({
  '--link-color': `var(--${color})`,
  '--link-color-active': `var(--${activeColor})`,
  ...style,
});
